export default {
  // Navigation
  nav_dashboard: "Dashboard",
  nav_alerts: "Alerts",
  nav_predictions: "Predictions",
  nav_resources: "Resources",
  nav_organizations: "Organizations",
  nav_settings: "Settings",
  nav_reports: "Reports",
  nav_home: "Home",
  nav_login: "Sign In",
  nav_signup: "Request Access",
  nav_logout: "Sign Out",

  // Auth
  auth_welcome_back: "Welcome Back",
  auth_sign_in: "Sign In",
  auth_email: "Email Address",
  auth_password: "Password",
  auth_forgot_password: "Forgot password?",
  auth_remember_me: "Keep me signed in for 30 days",
  auth_quick_login: "Quick login as demo user",
  auth_no_account: "Request access",
  auth_back_home: "Back to home",
  auth_invalid_credentials: "Invalid credentials. All demo accounts use password: demo",
  auth_password_hint: "Demo password for all accounts:",
  auth_reset_password: "Reset Password",
  auth_send_reset: "Send Reset Link",
  auth_check_email: "Check Your Email",
  auth_reset_sent: "If an account exists for {{email}}, you will receive a password reset link shortly.",
  auth_back_to_signin: "Back to Sign In",
  auth_sending: "Sending...",
  auth_signing_in: "Signing in...",

  // Landing
  landing_hero_title: "Predicting Malaria Outbreaks",
  landing_hero_subtitle: "Before They Happen",
  landing_hero_desc: "MalariaGuard empowers African health ministries and organizations with predictive intelligence to deploy resources proactively, save lives, and break the transmission cycle.",
  landing_access_dashboard: "Access Dashboard",
  landing_explore_features: "Explore Features",
  landing_features_title: "Built for the Frontlines",
  landing_features_subtitle: "Every feature designed with input from epidemiologists, health officers, and field workers across Cameroon and beyond.",
  landing_tech_title: "How EpiSense AI Works",
  landing_tech_subtitle: "A transparent look at the machine learning pipeline powering every prediction.",
  landing_testimonials_title: "Trusted by Frontline Teams",
  landing_testimonials_subtitle: "Hear from the epidemiologists, coordinators, and directors using MalariaGuard every day.",
  landing_pricing_title: "Simple, Transparent Pricing",
  landing_pricing_subtitle: "Choose the plan that fits your team. No hidden fees. Cancel anytime.",
  landing_cta_title: "Ready to Transform Malaria Response?",
  landing_cta_desc: "Join health ministries and organizations already using MalariaGuard to predict, prepare, and prevent malaria outbreaks across Africa.",
  landing_get_started: "Get Started Now",
  landing_request_access: "Request Access",

  // Dashboard
  dash_title: "Dashboard",
  dash_subtitle: "Real-time malaria outbreak surveillance & AI prediction overview",
  dash_predicted_cases: "Predicted Cases (2wk)",
  dash_growth_rate: "Growth Rate",
  dash_high_alert: "High-Alert Districts",
  dash_active_interventions: "Active Interventions",
  dash_vs_last: "vs. last period",
  dash_new_this_week: "new this week",
  dash_district_map: "District Risk Map",
  dash_cameroon_20: "Cameroon — 20 districts monitored",
  dash_national_trend: "National Case Trend",
  dash_weekly_confirmed: "Weekly confirmed cases, all districts",
  dash_activity_feed: "Live Activity Feed",
  dash_realtime_events: "Real-time platform events",
  dash_quick_alerts: "Quick Alerts",
  dash_weather_snapshot: "Weather Snapshot",
  dash_temp_rain: "Temperature & rainfall — last 7 days",
  dash_district_summary: "District Summary",
  dash_total_districts: "Total Districts",
  dash_pop_covered: "Population Covered",
  dash_high_risk: "High Risk",
  dash_medium_risk: "Medium Risk",
  dash_low_risk: "Low Risk",
  dash_district_leaderboard: "District Leaderboard",
  dash_top_5_growth: "Top 5 by predicted growth rate",
  dash_view_all: "View All",
  dash_last_7_days: "Last 7 Days",
  dash_refresh_data: "Refresh Data",
  dash_online: "Online",
  dash_last_sync: "Last sync: 3 min ago",

  // Alerts
  alerts_title: "Alerts",
  alerts_subtitle: "AI-classified outbreak alerts with recommended actions",
  alerts_filters: "Filters",
  alerts_export_csv: "Export CSV",
  alerts_region: "Region",
  alerts_severity: "Severity",
  alerts_status: "Status",
  alerts_date_from: "Date From",
  alerts_date_to: "Date To",
  alerts_search: "Search by district, alert ID, or action...",
  alerts_all_regions: "All Regions",
  alerts_all_severities: "All Severities",
  alerts_all_statuses: "All Statuses",
  alerts_ai_reasoning: "AI Reasoning",
  alerts_contributing_factors: "Contributing Factors",
  alerts_active_interventions: "Active Interventions",
  alerts_no_match: "No alerts match your filters",
  alerts_showing: "Showing {{count}} of {{total}} alerts",

  // Predictions
  pred_title: "Predictions",
  pred_subtitle: "XGBoost ML predictions with confidence bands and feature importance",
  pred_overview: "Prediction Overview",
  pred_features: "Feature Importance",
  pred_predicted_cases: "Predicted Cases",
  pred_confidence: "Confidence Score",
  pred_alert_level: "Alert Level",
  pred_confidence_range: "Confidence Range",
  pred_ci_desc: "95% confidence interval for predicted case count",
  pred_model_info: "Model Info",
  pred_algorithm: "Algorithm",
  pred_input_features: "Input Features",
  pred_training_data: "Training Data",
  pred_retrain: "Retrain Schedule",
  pred_last_trained: "Last Trained",
  pred_model_version: "Model Version",
  pred_pipeline_healthy: "Pipeline Healthy",
  pred_top_drivers: "Top 5 Outbreak Drivers",
  pred_drivers_desc: "Feature importance scores from XGBoost model",

  // Resources
  res_title: "Resources",
  res_subtitle: "Inventory management with low-stock warnings and demand forecasting",
  res_add_resource: "Add Resource",
  res_export_csv: "Export CSV",
  res_total_items: "Total Items",
  res_low_stock: "Low Stock",
  res_total_gap: "Total Gap",
  res_orgs: "Organizations",
  res_search: "Search resources...",
  res_all_districts: "All Districts",
  res_all_orgs: "All Organizations",
  res_low_stock_only: "Low Stock Only",
  res_resource: "Resource",
  res_type: "Type",
  res_quantity: "Quantity",
  res_district: "District",
  res_organization: "Organization",
  res_demand_gap: "Demand Gap",
  res_updated: "Updated",
  res_sufficient: "Sufficient",
  res_below_threshold: "Below threshold",

  // Organizations
  org_title: "Organizations",
  org_subtitle: "Partner organizations, active users, and engagement metrics",

  // Settings
  settings_title: "Settings",
  settings_subtitle: "Alert thresholds, user management, API keys, and system health",
  settings_your_role: "Your role:",
  settings_thresholds: "Alert Thresholds",
  settings_users: "User Management",
  settings_apikeys: "API Keys",
  settings_health: "System Health",
  settings_high_alert: "High Alert",
  settings_medium_alert: "Medium Alert",
  settings_low_normal: "Low / Normal",
  settings_threshold_desc: "Define growth rate thresholds that determine alert severity levels across all districts.",
  settings_high_desc: "Triggers when predicted growth rate exceeds this value. Full mobilization recommended.",
  settings_medium_desc: "Triggers when growth rate falls between medium and high thresholds. Enhanced surveillance.",
  settings_low_desc: "Growth rates below this threshold are considered normal. Routine surveillance continues.",
  settings_threshold_viz: "Threshold Visualization",
  settings_save: "Save Thresholds",
  settings_reset: "Reset Defaults",
  settings_all_users: "All Users",
  settings_manage_keys: "Manage access keys for external integrations",
  settings_create_key: "Create Key",
  settings_regenerate: "Regenerate",
  settings_revoke: "Revoke",
  settings_overall: "Overall Status",
  settings_avg_uptime: "Avg Uptime",
  settings_avg_latency: "Avg Latency",
  settings_last_incident: "Last Incident",
  settings_service_health: "Service Health",
  settings_role_sim: "Role-Based Access Simulator",
  settings_role_sim_desc: "Preview how the platform appears to different user roles.",

  // Reports
  reports_title: "Reports",
  reports_subtitle: "Exportable outbreak summaries and district comparison analytics",
  reports_outbreak_summary: "Outbreak Summary",
  reports_district_comparison: "District Comparison",
  reports_export_pdf: "Export PDF",
  reports_export_csv: "Export CSV",
  reports_date_range: "Date Range",
  reports_region_filter: "Region",
  reports_all_regions: "All Regions",
  reports_total_districts: "Total Districts",
  reports_high_risk: "High-Risk Districts",
  reports_cases_this_week: "Cases This Week",
  reports_avg_growth: "Avg Growth Rate",
  reports_interventions_active: "Active Interventions",
  reports_district: "District",
  reports_region: "Region",
  reports_population: "Population",
  reports_predicted_2wk: "Predicted (2wk)",
  reports_predicted_1mo: "Predicted (1mo)",
  reports_predicted_3mo: "Predicted (3mo)",
  reports_growth_rate: "Growth Rate",
  reports_alert_level: "Alert Level",
  reports_risk_trend: "Risk Trend",
  reports_resources_gap: "Resources Gap",
  reports_exported: "Report exported successfully",
  reports_comparing: "Comparing {{count}} districts",
  reports_no_data: "No data matches the selected filters",
  reports_weekly_trend: "Weekly Trend",
  // reports_outbreaks_prevented: "Outbreaks Prevented", // duplicate key removed

  reports_coverage: "Coverage",

  // Common
  common_save: "Save",
  common_cancel: "Cancel",
  common_delete: "Delete",
  common_edit: "Edit",
  common_add: "Add",
  common_search: "Search",
  common_filter: "Filter",
  common_reset: "Reset",
  common_close: "Close",
  common_loading: "Loading...",
  common_success: "Success",
  common_error: "Error",
  common_confirm: "Confirm",
  common_yes: "Yes",
  common_no: "No",
  common_showing: "Showing",
  common_of: "of",
  common_all: "All",
  common_live: "Live",
  common_normal: "Normal",
  common_warning: "Warning",
  common_critical: "Critical",
  common_operational: "Operational",
  common_degraded: "Degraded",
  common_active: "Active",
  common_acknowledged: "Acknowledged",
  common_resolved: "Resolved",
  common_high: "High",
  common_medium: "Medium",
  common_low: "Low",
  common_2weeks: "2 Weeks",
  common_1month: "1 Month",
  common_3months: "3 Months",
  common_dark_mode: "Dark Mode",
  common_light_mode: "Light Mode",

  // Language
  lang_en: "English",
  lang_fr: "French",
  lang_switch: "Language",

  // 404
  notfound_title: "Page Not Found",
  notfound_desc: "The page you're looking for doesn't exist or has been moved.",
  notfound_back_home: "Back to Home",
  notfound_back_login: "Back to Login",

  // Dashboard additional
  dash_good_morning: "Good morning",
  dash_good_afternoon: "Good afternoon",
  dash_good_evening: "Good evening",
  dash_avg_across_districts: "average across districts",
  dash_vs_last_week: "vs. last week",
  dash_live_badge: "Live",
  dash_yaounde_central: "Yaoundé Central",
  dash_2wk_horizon: "2wk",
  dash_all_filters: "All",
  dash_alert_filter: "Alert",
  dash_prediction_filter: "Prediction",
  dash_resource_filter: "Resource",

  // Alerts additional
  alerts_recommended_action: "Recommended Action",
  alerts_risk: "Risk",
  alerts_predicted: "Predicted",
  alerts_growth: "Growth",
  alerts_cases: "Cases",
  alerts_status_label: "Status",
  alerts_try_adjusting: "Try adjusting your filter criteria",

  // Predictions additional
  pred_chart_subtitle: "Historical cases vs. AI-predicted with 95% confidence interval",
  pred_legend_historical: "Historical",
  pred_legend_predicted: "Predicted",
  pred_legend_confidence: "Confidence",
  pred_prediction_start: "Prediction Start",
  pred_select_district: "Select a district to view feature importance",
  pred_population: "Population",
  pred_density: "Density",
  pred_coordinates: "Coordinates",
  pred_region_label: "Region",

  // Resources additional
  res_actions: "Actions",
  res_edit_resource: "Edit Resource",
  res_delete_confirm_title: "Delete Resource?",
  res_delete_confirm_desc: "This action cannot be undone. The resource will be permanently removed from the inventory.",
  res_showing: "Showing {{count}} of {{total}} resources",
  res_unit_label: "Unit",
  res_min_threshold_label: "Min Threshold",
  res_predicted_demand_label: "Predicted Demand",

  // Organizations additional
  org_active_org: "Active Organization",
  org_type: "Type",
  org_region: "Region",
  org_users_short: "Users",
  org_resources_short: "Resources",
  org_active_suffix: "active",
  org_team_members: "Team Members",
  org_invite_user: "Invite User",
  org_activity_logs: "Activity Logs",
  org_user_header: "User",
  org_role_header: "Role",
  org_status_header: "Status",
  org_last_active_header: "Last Active",
  org_actions_header: "Actions",
  org_invite_title: "Invite Team Member",
  org_full_name: "Full Name",
  org_send_invitation: "Send Invitation",
  org_no_logs: "No activity logs for this organization.",
  org_role_desc_viewer: "Viewers can only read data. Organization Users manage their org resources. Health Officers have full access. Admins manage users and settings.",

  // Settings additional
  settings_threshold_config_title: "Alert Threshold Configuration",
  settings_growth_threshold: "Growth Rate Threshold (%)",
  settings_below_threshold: "Below Threshold (%)",
  settings_viz_normal: "Normal",
  settings_viz_medium: "Medium",
  settings_viz_high: "High",
  settings_key_created: "Created",
  settings_key_last_used: "Last used",
  settings_key_status: "Status",
  settings_new_api_key: "New API Key",
  settings_never: "Never",
  settings_healthy: "Healthy",
  settings_last_incident_desc: "Map service degradation",
  settings_days_ago: "days ago",
  settings_role_desc_health_officer: "Full access to all features",
  settings_role_desc_org_user: "Org resources + shared predictions",
  settings_role_desc_admin: "User management + system settings",
  settings_role_desc_viewer: "Read-only dashboard + alerts",

  // Reports additional
  reports_national_confirmed_8wk: "National confirmed cases — last 8 weeks",
  reports_outbreak_metrics: "Outbreak Metrics",
  reports_active_interventions_metric: "Active Interventions",
  reports_pop_covered_metric: "Total Population Covered",
  reports_outbreaks_prevented: "Outbreaks Prevented (Est.)",
  reports_rdt_prepositioned: "RDT Kits Pre-positioned",
  reports_llin_distributed: "LLIN Nets Distributed",
  reports_risk_by_region: "Risk by Region",
  reports_actions: "Actions",
  reports_view_predictions: "View predictions",
  reports_view_alerts: "View alerts",
  reports_ok: "OK",
  reports_showing_districts: "Showing {{count}} of {{total}} districts",
  reports_clear_region: "Clear region filter",

  // Login additional
  auth_signin_desc: "Sign in to access the malaria outbreak prediction platform",

  // Signup
  auth_request_access_title: "Request Access",
  auth_request_desc: "Apply for access to the MalariaGuard outbreak prediction platform",
  auth_full_name: "Full Name",
  auth_organization: "Organization",
  auth_requested_role: "Requested Role",
  auth_region_district: "Region / District",
  auth_select_region: "Select your region",
  auth_reason_access: "Reason for Access",
  auth_reason_placeholder: "Describe your role and why you need access to the platform...",
  auth_submit_request: "Submit Request",
  auth_submitting: "Submitting...",
  auth_request_submitted: "Request Submitted",
  auth_request_submitted_desc: "Your access request has been sent to the platform administrator.",
  auth_redirecting: "Redirecting to sign in...",
  auth_already_have_access: "Already have access? Sign in",
  auth_char_count: "({{count}}/500)",

  // Landing additional
  landing_hero_badge: "AI-Powered Outbreak Prediction",
  landing_trusted_by: "Trusted by",
  landing_preview_title: "The Mission Control",
  landing_preview_desc: "A unified dashboard that brings together predictions, alerts, resources, and weather data in one intuitive interface.",
  landing_most_popular: "Most Popular",
  landing_footer_moh: "Ministry of Public Health, Cameroon",
  landing_footer_built: "Built with AI for Africa",

  // Sidebar
  sidebar_collapse: "Collapse",
  sidebar_expand: "Expand",

  // Topbar
  topbar_platform: "EpiSense Platform",
  topbar_mark_all_read: "Mark all read",
};